import { Injectable, signal, WritableSignal } from '@angular/core';
import { HttpService } from '../helper/http.service';
import { Subscription } from 'rxjs';
import { CustomerService } from '@services/customer/customer.service';
import { QueryChange } from '@dashboard_models/rtdb';
import { AW } from '@airwallet/types';
@Injectable({
    providedIn: 'root'
})
export class HomeService {
    customerDetails: WritableSignal<AW.Account.Details | null> = signal(null);
    loadingCustomerDetails: WritableSignal<boolean> = signal(true);

    constructor(
        private http: HttpService,
        private customerService: CustomerService
    ) {}

    async getAvailableFunds(): Promise<AW.BankAccount.AvailableFunds[]> {
        return this.http._http('payout', 'funds/available', 'get');
    }
    async payoutNow(baDocId: string): Promise<any> {
        return this.http._http('payout', `payout-now/${baDocId}`, 'post');
    }
    async fetchUserAsAdmin(): Promise<AW.Account.ShallowUserRecord> {
        return this.http.dynamicHttp('api_account/fetch_user', 'get');
    }

    /**
     * CustomerDetails are fetched on ngInit in Home.
     */
    async getCustomerDetails(uid: string): Promise<void> {
        return new Promise(resolve => {
            const customerDetailsSub: Subscription = this.customerService.readCustomerDetails(uid).subscribe(async (customerDetailsQuery: QueryChange) => {
                customerDetailsSub.unsubscribe();
                this.customerDetails.set(customerDetailsQuery.snapshot.val());
                if (!customerDetailsQuery.snapshot.child('onboarding_state').exists()) return;

                return resolve();
            });
        });
    }
}
